import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthService } from '../services/authService';

const GoogleCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = () => {
      const error = searchParams.get('error');

      if (error) {
        // Redirect to login with error message
        navigate(`/login?error=${error}`);
        return;
      }

      // Check if we have user_data from backend redirect (signup flow)
      // This happens AFTER backend processes OAuth and redirects back
      const userDataParam = searchParams.get('user_data');
      const signupParam = searchParams.get('signup');

      if (signupParam === 'true' && userDataParam) {
        try {
          // Parse user data from URL parameter
          const userData = JSON.parse(decodeURIComponent(userDataParam));

          // Store OAuth user data for registration
          const oauthUserData = {
            name: userData.name || '',
            email: userData.email || '',
            username: userData.email || '',
            login_type: 3, // Google
            oauth_token: userData.google_id || '',
          };

          localStorage.setItem('oauth_signup_data', JSON.stringify(oauthUserData));
          console.log('[GoogleCallback] Stored OAuth signup data, redirecting to register');

          // Redirect to register page
          navigate('/register');
          return;
        } catch (err: any) {
          console.error('[GoogleCallback] Signup flow error:', err);
          navigate(`/register?error=${encodeURIComponent(err.message || 'Google signup failed')}`);
          return;
        }
      }

      // For signin flow, check for token and user parameters
      const token = searchParams.get('token');
      const userString = searchParams.get('user');

      if (token && userString) {
        try {
          // Parse user data
          const user = JSON.parse(decodeURIComponent(userString));

          // Use AuthService for consistent token and user data storage
          AuthService.setToken(token, { expires: 7 });
          AuthService.setUserData(user);

          // Store user info in localStorage for backward compatibility
          localStorage.setItem('crm_user', JSON.stringify(user));

          // Redirect to leads page (admin view for client_id = 9)
          const clientId = user?.client_id_fk;
          const isAdminClient = clientId === 9 || clientId === '9';
          navigate(isAdminClient ? '/leads_admin' : '/leads');
        } catch (err) {
          console.error('Error processing Google login:', err);
          navigate('/login?error=Failed to process login');
        }
      } else {
        navigate('/login?error=Invalid response from server');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-brandColor mx-auto mb-4"></div>
        <h2 className="text-2xl font-bold text-white">Completing Google Login...</h2>
        <p className="text-slate-300 mt-2">Please wait while we redirect you</p>
      </div>
    </div>
  );
};

export default GoogleCallback;